import { z } from "zod";

export const DiningTableSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1).max(40),
  area: z.string().max(40).nullable(),
  seats: z.number().int().positive().nullable(),
  sortOrder: z.number().int(),
  isActive: z.boolean(),
});
export type DiningTable = z.infer<typeof DiningTableSchema>;

export const TableStateSchema = z.enum(["free", "seated", "ready", "paid"]);
export type TableState = z.infer<typeof TableStateSchema>;

export const TableWithStateSchema = DiningTableSchema.extend({
  state: TableStateSchema,
  openOrderIds: z.array(z.string().uuid()),
  openTotalCents: z.number().int().nonnegative(),
  seatedSince: z.string().datetime().nullable(),
});
export type TableWithState = z.infer<typeof TableWithStateSchema>;
